export default "__VITE_ASSET__7ec4763e__"